import { FC, useEffect, useState } from "react";
import config from "../config/environment";

/**
 * Selo visual de ambiente. Aparece em qualquer build que NÃO seja produção
 * (REACT_APP_ENVIRONMENT !== 'production'), ajudando a evitar confundir DEV com PRD.
 * Em produção retorna null e não renderiza nada.
 */
const STORAGE_KEY = "env_badge_hidden";

const EnvironmentBadge: FC = () => {
    const [hidden, setHidden] = useState(false);

    useEffect(() => {
        try {
            setHidden(sessionStorage.getItem(STORAGE_KEY) === "1");
        } catch {
            // ignore
        }
    }, []);

    if (config.isProduction()) {
        return null;
    }

    if (hidden) {
        return null;
    }

    const projectId = config.firebase.projectId;
    const env = (config.environment || "development").toUpperCase();

    const handleHide = () => {
        try {
            sessionStorage.setItem(STORAGE_KEY, "1");
        } catch {
            // ignore
        }
        setHidden(true);
    };

    return (
        <>
            {/* Moldura tracejada ao redor da tela inteira */}
            <div className="pointer-events-none fixed inset-0 z-[9998] border-4 border-amber-400/70 border-dashed" />

            {/* Etiqueta no rodapé */}
            <div className="fixed bottom-3 left-3 z-[9999] flex items-center gap-2 rounded-full bg-amber-500 px-3 py-1.5 text-xs font-bold text-amber-950 shadow-lg">
                <span className="relative flex h-2 w-2">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber-900/40" />
                    <span className="relative inline-flex h-2 w-2 rounded-full bg-amber-900" />
                </span>
                <span>AMBIENTE {env}</span>
                <span className="font-medium opacity-80">· {projectId}</span>
                <button
                    type="button"
                    onClick={handleHide}
                    className="ml-1 rounded-full px-1 text-amber-900/70 transition-colors hover:bg-amber-600 hover:text-amber-950"
                    aria-label="Ocultar selo de ambiente"
                    title="Ocultar até recarregar"
                >
                    ×
                </button>
            </div>
        </>
    );
};

export default EnvironmentBadge;
